import React from 'react';
import type { AccessType } from '@/lib/types/dto/authentication';

type Props = {
  allow?: AccessType;
  children: React.ReactNode;
};

/**
 * Renders children when the user has the allowed role.
 * For now always renders children; hook up to auth/roles when available.
 */
export default function RestrictedComponent({ children }: Props) {
  return <>{children}</>;
}
